var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcuador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0107C0 7.17424 7.1635 0.0107422 16 0.0107422C24.8365 0.0107422 32 7.17424 32 16.0107L16 17.4021L0 16.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.14099 24.0105C4.90755 28.7928 10.0778 32.0105 16 32.0105C21.9222 32.0105 27.0924 28.7928 29.859 24.0105L16 22.967L2.14099 24.0105Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.859 24.0107C31.2204 21.6574 32 18.9252 32 16.0107H0C0 18.9252 0.779625 21.6574 2.141 24.0107H29.859Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5759C19.0736 21.5759 21.5652 19.0843 21.5652 16.0107C21.5652 12.9371 19.0736 10.4455 16 10.4455C12.9264 10.4455 10.4348 12.9371 10.4348 16.0107C10.4348 19.0843 12.9264 21.5759 16 21.5759Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 19.489C14.0822 19.489 12.5219 17.9286 12.5219 16.0107V13.9238C12.5219 12.0058 14.0822 10.4455 16.0001 10.4455C17.918 10.4455 19.4783 12.0059 19.4783 13.9238V16.0107C19.4783 17.9287 17.918 19.489 16.0001 19.489Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5651 7.6631H17.3911C17.3911 6.89473 16.7682 6.27179 15.9998 6.27179C15.2314 6.27179 14.6085 6.89473 14.6085 7.6631H10.4346C10.4346 8.43154 11.1039 9.05441 11.8722 9.05441H11.8259C11.8259 9.82285 12.4488 10.4457 13.2172 10.4457C13.2172 11.2142 13.8401 11.837 14.6085 11.837H17.3911C18.1596 11.837 18.7824 11.2142 18.7824 10.4457C19.5509 10.4457 20.1737 9.82285 20.1737 9.05441H20.1274C20.8958 9.05441 21.5651 8.43147 21.5651 7.6631V7.6631Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcuador);
export default __webpack_public_path__ + "static/media/ecuador.d653f431.svg";
export { ForwardRef as ReactComponent };